import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NavigateBeforeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"navigate_before"}/>
}
